<template>
  <div class="bg-contentPlayerBg">
    <swiper
        ref="mySwiper"
        :options="swiperOption"
        class="gallery-top"
        @slideChange="changeSwiperIndex"
    >
      <swiper-slide
          v-for="(links, k) in linkUrl"
          :key="k"
          class="html-slide"
      >
        <iframe
            :src="links"
            class="html_iframe"
            frameborder="0"
            height="100%"
            scrolling="0"
            title="description"
            width="100%"
        ></iframe>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import {swiper, swiperSlide} from "vue-awesome-swiper";
import htmlvideo from "@/json/htmlvideo.json";
import {htmlTypeMixins} from "@/mixins/htmlType.js";
import microLearnApi from "@/api/microLearnApi";

export default {
  name: "HtmlType",

  mixins: [htmlTypeMixins],

  components: {
    swiper,
    swiperSlide,
  },

  watch: {
    setSlideNumber() {
      this.mySwiper.slideTo(this.setSlideNumber - 1);
    },
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  data() {
    return {
      lessonDataObj: null,
      linkUrl: '',
      myJson: htmlvideo,
      swiperOption: {
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "fraction",
        },
      },
      slideSwiper: null,
      progressBar: 0,
    }
  },

  mounted() {
    console.log('M MOUNTED')
    this.fetchLessonContents();
    this.slideSwiper = this.$refs.mySwiper.swiper;
  },

  methods: {
    changeSwiperIndex() {
      this.currentSliderIndex = this.$refs.mySwiper.swiper.realIndex;
      if (this.countFile === parseInt(this.currentSliderIndex + 1)) {
        this.addOpacityClass = true
      } else {
        this.addOpacityClass = false
      }

      let params = {
        total: this.countFile,
        current: this.currentSliderIndex + 1,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };

      let progressBarLength;
      progressBarLength = Math.floor(params.current * 100 / params.total);

      if (parseInt(progressBarLength)) {
        this.progressBar = progressBarLength;
      } else {
        this.progressBar = 0;
      }
    },

    fetchLessonContents() {
      let params = this.setParams();
      microLearnApi.learnLessonContents(params).then(response => {
        this.lessonDataObj = response.data.data;
        this.linkUrl = this.lessonDataObj.html.files.filter((url) => !url.includes("__MACOSX"))
      });
    },

    // API 파라미터 설정(set parameter)
    setParams() {
      let params = {
        total: this.slideFiles.length,
        current: this.currentSlide,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId
      };
      return params;
    },
  }
}
</script>

<style scoped>

</style>
